import React, { useState, useEffect } from 'react';
import './HowTo.css';

function HowToContents() {
  const [howTos, setHowTos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHowTos = async () => {
      try {
        const response = await fetch('/api/how-tos');
        if (!response.ok) throw new Error('Failed to fetch how-tos');
        const data = await response.json();
        setHowTos(data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchHowTos();
  }, []);

  if (loading) return <div className='is-flex is-flex-direction-rows is-justify-content-center'>Loading...</div>;
  if (error) return <div className='is-flex is-flex-direction-rows is-justify-content-center'>Error: {error}</div>;

  return (
    <div className='columns is-flex is-flex-direction-rows is-justify-content-center'>
      <div className="column is-8-fullhd is-8-widescreen is-10-desktop is-10-tablet is-10-mobile">
        <div className="columns">
          {/* Main Content Column */}
          <div className="p-0 m-0 column is-8">
          <h3 className='pt-2 m-0 '>Get started</h3>
          <p className='pt-0 pb-5 m-0 is-medium'>Compose a new email or forward an existing email. In the recipient or "To:" field, the portion before the "@" symbol is what you customize. A Nudge will always end with "@nudgemail.com." Put whatever you want in the subject and body of the email. That's it. Just pure productivity magic.</p>
            {howTos.map((section, index) => (
              <div key={index} id={section.category.toLowerCase().replace(/\s+/g, '-')} className="p-0 mx-0 mb-4">
                <h3 className="is-bold is-4">{section.category}</h3>
                <p className="subtitle is-6 mb-4">{section.description}</p>
                
                <div className="p-0 m-0 table-container">
                  <table className="table is-fullwidth command-table">
                    <tbody>
                      {section.rules.map((rule, ruleIndex) => (
                        <tr key={ruleIndex} className={ruleIndex % 2 === 0 ? 'even-row' : 'odd-row'}>
                          <td>{rule}</td>
                        </tr>
                      ))}
                      {section.example && (
                        <tr className="example-row">
                          <td>{section.example}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
          </div>

          {/* Table of Contents Column */}
          <div className="column is-4">
            <div className="toc-container">
              <div className="box py-5 px-6">
                <h3 className="p-0 m-0 is-bold is-4">Table of contents</h3>
                <p className='pb-4 m-0'>Send a Nudge by specifying...</p>
                <ul className="toc-list">
                  {howTos.map((section, index) => (
                    <li key={index}>
                      <a className='textLink' href={`#${section.category.toLowerCase().replace(/\s+/g, '-')}`}>
                        {section.category}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HowToContents;